module.exports = __webpack_public_path__ + "static/derjenige-der-nicht-weiß-zu-lieben-kampft-05-8dbb160a4daca2136f80c4170c350c84.jpg";